import { render } from "./NavigationContainer.vue?vue&type=template&id=b5c8bf66&scoped=true&ts=true"
import script from "./NavigationContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationContainer.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationContainer.vue?vue&type=style&index=0&id=b5c8bf66&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c8bf66"],['__file',"src/components/NavigationContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5c8bf66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5c8bf66', __exports__)) {
    console.log('reload')
    api.reload('b5c8bf66', __exports__)
  }
  
  module.hot.accept("./NavigationContainer.vue?vue&type=template&id=b5c8bf66&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('b5c8bf66', render)
  })

}


export default __exports__